module.exports = __webpack_public_path__ + "static/media/0326_IMG_LES_ENSEIGNES_LE_POISSONNIER_SCRABBLE.eb9a6cb0.webp";